module.exports = __webpack_public_path__ + "img/categoria-6.eca1ca4f.png";